// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1":"f20fc10f","53":"b7732f8a"}[chunkId] + ".chunk.css");